import axios from 'axios'
import { useEffect, useState } from 'react'
import { popupCenter } from '../helpers/window.helpers'
import { useChatStore } from '../stores/chat.store'

const BACKEND_URL = process.env.REACT_APP_API_BASE_URL

export default function useLogin() {
	const { setAccessToken, setSystemUser } = useChatStore()

	const [windowOpened, setWindowOpened] = useState(null)
	const [authState, setAuthState] = useState(null)
	const [url, setUrl] = useState('')
	const [ticker, setTicker] = useState(null)

	const onLogin = async provider => {
		const { data } = await axios.post(`${BACKEND_URL}authenticate`, {
			provider,
			referer: 'crm',
		})
		if (data) {
			setAuthState(data)
		}
	}

	const checkAuth = async () => {
		if (!authState || !authState.code) return

		const { data } = await axios.get(
			`${BACKEND_URL}authenticate/${authState.code}`
		)

		if (data.error) {
			alert(data.message)
			if (ticker) {
				clearInterval(ticker)
				setTicker(null)
			}
			setAuthState(null)
			return
		}
		if (data) {
			setAuthState(data)
		}
	}

	useEffect(() => {
		if (!authState) {
			if (ticker) {
				clearInterval(ticker)
				setTicker(null)
			}
			return
		}

		setUrl(authState.url)

		if (!ticker && !authState.accessToken) {
			setTicker(setInterval(checkAuth, 2000))
		}

		if (authState.accessToken) {
			// удаляем url тем самым закрываем окно
			setUrl('')

			if (ticker) {
				clearInterval(ticker)
				setTicker(null)
			}

			setAccessToken(authState.accessToken)

			if (authState.systemUser) {
				setSystemUser(authState.systemUser)
			}
		}
	}, [authState])

	useEffect(() => {
		// Открываем окно с переходом в бота, сохраняем его в стейт, чтобы потом закрыть
		if (!windowOpened && url) {
			const _windowOpened = popupCenter(url, 550, 300)
			setWindowOpened(_windowOpened)
		}

		// закрывает окно
		if (windowOpened && !url) {
			windowOpened.close()
			setWindowOpened(null)
		}
	}, [windowOpened, url])

	return {
		authState,
		setAuthState,
		url,
		onLogin,
	}
}
